<template>
  <v-card v-if="displayText" tile elevation="0" :class="grid.outer">
    <v-row
      no-gutters
      :justify="settings.justify"
      :style="
        'min-height: ' +
          settings.boxHeight +
          'px;' +
          'margin-left: ' +
          marginLeftResponsive +
          'px;' +
          'margin-right: ' +
          marginRightResponsive +
          'px;'
      "
      :align="settings.align"
    >
      <v-col xs="12" :md="settings.cols">
        <v-card tile elevation="0" :class="grid.inner">
          <div
            :style="
              'font-family: ' +
                settings.font +
                ' !important;' +
                'color: ' +
                settings.color +
                ';' +
                'font-size: ' +
                settings.size +
                'px;' +
                'font-weight: ' +
                settings.weight +
                ';' +
                'line-height: ' +
                settings.lineHeight +
                ';' +
                'font-style: ' +
                settings.style +
                ';'
            "
            :class="settings.floatText"
          >
            <div v-if="isHtml" v-html="text"></div>
            <v-clamp v-else autoresize :max-lines="lines">
              {{ strippedText }}
            </v-clamp>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import VClamp from "vue-clamp";

export default {
  components: {
    VClamp
  },
  // Props
  // Settings = the typography settings (required)
  // Value = the actual text to be displayed (optional, falls back to settings.value)
  // Lines = the number of lines to truncate if required. No value passed will display all lines
  // Suffix = some text to display after the value
  props: {
    settings: {
      type: Object,
      required: true,
      default: () => ({})
    },
    value: {
      type: [String, Number],
      default: null
    },
    lines: {
      type: Number,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    isHtml: {
      type: Boolean,
      default: false
    }
  },
  created() {
    // this.locale = this.$i18n.locale
    // console.log(this.text);
  },
  computed: {
    /**
     * Determines what text to display based on available props and settings
     * Priority: value prop > settings.value > fallback text
     */
    displayText() {
      // Check if we have any text to display
      return (
        this.value ||
        (this.settings && this.settings.value) ||
        (this.settings && this.settings.fallbackText) ||
        false
      );
    },
    text() {
      let val;

      // Priority order for text source:
      // 1. Explicit value prop
      // 2. Settings value
      // 3. Fallback text from settings
      // 4. Default fallback
      if (
        this.value !== null &&
        this.value !== undefined &&
        this.value !== ""
      ) {
        val = this.value;
      } else if (this.settings && this.settings.value) {
        val = this.settings.value;
      } else if (this.settings && this.settings.fallbackText) {
        val = this.settings.fallbackText;
      } else {
        val = "Text not configured";
      }

      // Add suffix if provided
      if (this.suffix) {
        return this.$t(val) + " " + this.$t(this.suffix);
      } else {
        return this.$t(val);
      }
    },
    /**
     * Returns text with HTML tags stripped for plain text display
     */
    strippedText() {
      // Create a temporary div element to parse HTML
      const div = document.createElement("div");
      div.innerHTML = this.text;
      return div.textContent || div.innerText || "";
    },
    grid() {
      return this.$store.getters.grid;
    },
    marginLeftResponsive() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 8;
        case "sm":
          return 8;
        case "md":
          return 8;
        case "lg":
          return this.settings.marginLeft;
        case "xl":
          return this.settings.marginLeft;
      }
      return this.settings.marginLeft;
    },
    marginRightResponsive() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 8;
        case "sm":
          return 8;
        case "md":
          return 8;
        case "lg":
          return this.settings.marginRight;
        case "xl":
          return this.settings.marginRight;
      }
      return this.settings.marginRight;
    }
  },
  methods: {}
};
</script>

<style scoped>
/* Force all hyperlinks in HTML content to be blue and underlined */
::v-deep a {
  color: #1976d2 !important;
  text-decoration: underline !important;
}

/* Additional specificity for nested elements */
::v-deep div a,
::v-deep p a,
::v-deep span a,
::v-deep strong a,
::v-deep em a,
::v-deep b a,
::v-deep i a {
  color: #1976d2 !important;
  text-decoration: underline !important;
}
</style>
